import type { ScenarioRow } from '../Dashboard';

const SEED_SCENARIOS: ScenarioRow[] = [
  {
    id: '1',
    loanId: '2610290001',
    name: 'Smith Purchase 30yr',
    channelType: 'Retail',
    ltv: '80.000',
    fico: '760',
    occupancy: 'Primary Residence',
    createdDate: '10/20/2026',
    modifiedDate: '10/27/2026',
  },
  {
    id: '2',
    loanId: '2610290002',
    name: 'Jones Refi FHA',
    channelType: 'Wholesale',
    ltv: '96.500',
    fico: '680',
    occupancy: 'Primary Residence',
    createdDate: '10/22/2026',
    modifiedDate: '10/22/2026',
  },
  {
    id: '3',
    loanId: '2610290003',
    name: 'Lee Investment 15yr',
    channelType: 'Correspondent',
    ltv: '70.000',
    fico: '740',
    occupancy: 'Investment',
    createdDate: '10/24/2026',
    modifiedDate: '10/28/2026',
  },
];

const CHANNELS = ['Retail', 'Wholesale', 'Correspondent'];
const OCCUPANCIES = ['Primary Residence', 'Second Home', 'Investment'];

// Extra generated rows so the grid has more than one page.
const GENERATED_SCENARIOS: ScenarioRow[] = Array.from(
  { length: 22 },
  (_, index) => {
    const id = String(index + SEED_SCENARIOS.length + 1);
    const day = String((index % 28) + 1).padStart(2, '0');
    return {
      id,
      loanId: `261029${id.padStart(4, '0')}`,
      name: `Test Scenario ${id}`,
      channelType: CHANNELS[index % CHANNELS.length],
      ltv: (60 + (index % 8) * 5).toFixed(3),
      fico: String(640 + (index % 9) * 20),
      occupancy: OCCUPANCIES[index % OCCUPANCIES.length],
      createdDate: `09/${day}/2026`,
      modifiedDate: `10/${day}/2026`,
    };
  },
);

export const MOCK_SCENARIOS: ScenarioRow[] = [
  ...SEED_SCENARIOS,
  ...GENERATED_SCENARIOS,
];
